import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';
import { Component, Input, OnInit } from '@angular/core';
import { ImportExcel } from 'src/app/services/importExcel/import-excel.service';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';

@Component({
  selector: 'aims-import',
  templateUrl: './aims-import.component.html',
  styleUrls: ['./aims-import.component.css']
})
export class AimsImportComponent implements OnInit {

constructor(private exportToExcelService: ImportExcel,
    private transferHttp: TransferHttpService) {}

  @Input() importType: string;
  @Input() configFile: string;
  @Input() importUrl: string;

  allowedExtensions: string = ".xlsx";
  maxFileSize:number = 4194304;
  importFileName: string;
  config: any;
  diff: number;
  result: string;
  importErrors = [];
  showResults: boolean = false;
  showFileUpload: boolean = false;
  importPoint: string;
  showSpinner: boolean = false;

  // AimsCommonTable setup
  errorsHeader: AimsCommonTableHeader[] = [
    { key: 'rowNumber', label: 'Row', type: 'number', width: 80 },
    { key: 'colNumber', label: 'Column', type: 'number', width: 80 },
    { key: 'error', label: 'Error', type: 'string' },
  ];
  errorsPermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    filter: false
  };

  ngOnInit(): void {
    this.transferHttp.get(this.configFile).subscribe(ret => {
      this.config = ret;
    });

    const d = new Date();
    this.diff = d.getTimezoneOffset();
    this.importPoint = this.importUrl + '?diff='+this.diff;
  }

  generate() {
    this.exportToExcelService.generate(this.config);
  }

  import() {
    this.result = null;
    this.importErrors.length = 0;
    this.showFileUpload = true;
    this.showResults = false;
  }

  uploaded() {
    this.showSpinner = true;
  }

  public error(event) {
    this.showFileUpload = false;
    this.result = `Error : ${event.error}`;
    this.showResults = true;
    this.showSpinner = false;
  }

  public success(event) {
    this.showSpinner = false;
    this.showFileUpload = false;
    this.result = `Rows Imported : ${event.body.rowsImported}`;

    this.importErrors = event.body.errors;
    this.showResults = true;
  }

}
